// Central link to the live customer booking portal.
export const BOOKING_URL = "https://bookingg.purohithconnect.com";

// Per-pooja deep links are not yet supported by the portal, so every booking
// link currently resolves to the portal home. Pass a pooja slug now and the
// deep link will activate automatically once the portal exposes per-ceremony URLs.
export const bookingUrl = (/* poojaSlug */) => BOOKING_URL;

// Fire the "book_now_click" conversion event (GA4 + Meta via pcTrack in index.html).
// Safe no-op until an analytics ID is configured at build time.
export const trackBooking = ({ location = "", pooja = "" } = {}) => {
  try {
    const params = {
      source: typeof window !== "undefined" ? window.location.pathname : "",
      cta_location: location || "unknown",
    };
    if (pooja) params.pooja = pooja;
    if (typeof window !== "undefined" && typeof window.pcTrack === "function") {
      window.pcTrack("book_now_click", params);
    }
  } catch (_) {}
};

// Open the booking portal in a new tab, firing the conversion event first.
export const openBooking = (opts = {}) => {
  // Some buttons pass a role string (e.g. "Family"); ignore non-object args.
  const o = opts && typeof opts === "object" ? opts : {};
  trackBooking(o);
  window.open(bookingUrl(o.pooja), "_blank", "noopener,noreferrer");
};
